// Main Childpool Component
import { useEffect, useState } from "react";
import "./childpool.scss";
import { unifarmFactory } from "../../utils/contract";
import { apiRequest } from "../../api/apiService";
import useWallet from "../../hooks/useWallet";
import { UNIFARM_CREATEDS_QUERY } from "../../api/queries";
import { useChildpoolCreation } from "./hooks";
import { useTokenAllowance } from "../../hooks/useTokenAllowance";
import { fetchMetadata } from "../../utils/fetchMetaData";
import Loader from "../../shared/Loader";
import useIPFSMetadata from "../../hooks/useIPFSMetadata";
import { useProfile } from "../../hooks/useProfile";
import { useTokenBalance } from "../../hooks/useTokenBalance";
import { useHistory } from "react-router-dom";

// Import child components
import { BasicInfoStep, FeesStep, StakeTokensStep, FinalizeStep, StepIndicator } from "./steps";
import { SuccessModal, FailureModal } from "./modals";
import { useChainSwitch } from "../../hooks/useChainSwitch";
import { ApiUrl } from "../../utils/ApiUrl";
import { useTheme } from "../../hooks/ThemeProvider";
const Childpool = () => {

  const history = useHistory()
  const [currentStep, setCurrentStep] = useState(1);
  const { address } = useWallet();
  const [rootTokens, setRootTokens] = useState([]);
  const { generateIPFSMetadata, isUploadingMetadata, metadataError } = useIPFSMetadata();
  const { userProfile } = useProfile(true)
  // console.log(userProfile, "Profile")

  const { switchToChain } = useChainSwitch();
  const [formData, setFormData] = useState({
    searchTerm: "",
    selectedToken: null,
    tagline: "",
    poolDescription: "",
    creatorFee: 1,
    stakingAmount: "",
    profile: ""
  });
  const { theme } = useTheme();
  const [rewardToken, setRewardToken] = useState()
  const [errors, setErrors] = useState({});
  const [loaderText, setLoaderText] = useState("");
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [trxHash, setTrxHash] = useState("");
  const [gasInfo, setGasInfo] = useState(null);

  const [childPoolId, setChildPoolId] = useState(null);


  // Hooks
  const { estimateChildpoolCreationGas, createChildpool, isEstimatingGas, isCreatingPool } = useChildpoolCreation();
  const { ensureAllowance, isApprovingToken } = useTokenAllowance();
  const { checkTokenBalance } = useTokenBalance()

  // Validation functions
  const isBlank = (value) => !value || !String(value).trim();
  const isPositiveNumber = (value) => {
    if (value === null || value === undefined) return false;
    const n = Number(value);
    return !Number.isNaN(n) && n > 0;
  };

  const cropAddress = (addr) => {
    if (!addr || typeof addr !== 'string') return '—';
    const trimmed = addr.trim();
    if (trimmed.length <= 10) return trimmed;
    return `${trimmed.substring(0, 6)}...${trimmed.substring(trimmed.length - 4)}`;
  };

const validateStep = (stepNumber) => {
  const stepErrors = {};

  if (stepNumber === 1) {
    if (!formData.selectedToken)
      stepErrors.selectedToken = "Please select a root pool.";

    if (isBlank(formData.tagline)) {
      stepErrors.tagline = "Tagline is required.";
    } else {
      const wordCount = formData.tagline.trim().length;
      if (wordCount < 3)
        stepErrors.tagline = "Tagline must be at least three characters.";
    }

    if (isBlank(formData.poolDescription))
      stepErrors.poolDescription = "Description is required.";
  }

  if (stepNumber === 2) {
    if (formData.creatorFee < 0 || formData.creatorFee > 2.5)
      stepErrors.creatorFee = "Creator fee must be between 0% and 2.5%.";
  }

  if (stepNumber === 3) {
    if (!isPositiveNumber(formData.stakingAmount))
      stepErrors.stakingAmount = "Enter a valid staking amount greater than 0.";
  }

  // console.log(stepErrors, "Step errors");
  setErrors(stepErrors);
  return Object.keys(stepErrors).length === 0;
};

  // Navigation functions
  const handleNextStep = (step) => {
    const stepToValidate = step - 1;
    if (validateStep(stepToValidate)) {
      setCurrentStep(step);
    }
  };

  const handlePreviousStep = () => {
    setErrors({});
    setCurrentStep(currentStep - 1);
  };

  const handleClose = () => {
    setShow(false)
    history.push("/")
  };
  const handleShow = () => setShow(true);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  // Data fetching
  const fetchRootTokens = async () => {
    try {
      setLoader(true);
      setLoaderText("Loading root tokens...");

      const data = await apiRequest({
        url: `${ApiUrl}/pool/root-pools`,
        method: "GET",
        params: { limit: 100 },
        // data: {
        //   query: UNIFARM_CREATEDS_QUERY,
        // },
        auth: true,
      });

      // console.log(data)
      const pools = data?.data?.items;
      const filteredPools = pools?.filter(pool => {
        const poolEndDate = new Date(pool?.poolEndDate);
        const currentDate = new Date();
        return poolEndDate >= currentDate;
      })
      setRootTokens(filteredPools)


    } catch (error) {
      console.error("❌ Error fetching root tokens:", error);
      setRootTokens([]); // fallback to empty list
    } finally {
      setLoader(false);
      setLoaderText("");
    }
  };


  const getSelectedContractAddress = () => {
    const token = formData.selectedToken || {};
    return token.contractAddress;
  };

  useEffect(() => {
    if (formData?.selectedToken) {
      // console.log(formData?.selectedToken, "Selecteed Token")
      getRewardToken(formData?.selectedToken?.rewardToken)

    }

  }, [formData?.selectedToken])

  const getRewardToken = async (rewardToken) => {
    const token = await checkTokenBalance(rewardToken, address)
    // console.log(token)
    setRewardToken(token)

  }

  // Gas estimation
  useEffect(() => {
    const estimate = async () => {
      if (currentStep !== 4) return;
      const contractAddress = getSelectedContractAddress();
      const rewardAmount = formData.stakingAmount;
      const tokenDecimals = formData?.selectedToken?.tokenDecimals || 18; // ✅ default fallback

      if (!contractAddress || !rewardAmount) return;

      try {
        const result = await estimateChildpoolCreationGas(
          address,
          contractAddress,
          formData.creatorFee,
          rewardAmount,
          "ipfs://QmZxdSaqp4Hni1pKWZDLqVhYh8ZbN4rtHdFbLywt8F7xTM",
          tokenDecimals
        );
        setGasInfo(result);
      } catch (e) {
        setGasInfo(null);
        console.error(e);
      }
    };
    estimate();
  }, [currentStep, formData.stakingAmount, formData.selectedToken, address, isApprovingToken, isCreatingPool]);


  // Main transaction handler
  const handleStakeAndFinalize = async () => {
    // console.log("Child pool")
    if (isApprovingToken || isCreatingPool) return;
    // console.log("hello")
    if (!validateStep(3)) return;


    const contractAddress = formData.selectedToken?.contractAddress;
    const rewardAmount = formData.stakingAmount;

    if (!contractAddress || !rewardAmount) {
      setErrors({
        stakingAmount: !rewardAmount ? 'Enter a valid staking amount greater than 0.' : undefined,
        selectedToken: !formData.selectedToken ? 'Please select a root pool.' : undefined
      });
      return;
    }

    try {
      setLoader(true);
      await switchToChain();
      setLoaderText("Generating IPFS metadata...");

      formData.profile = userProfile;

      const metadataResult = await generateIPFSMetadata(formData);
      if (!metadataResult.success) {
        throw new Error(`Failed to upload metadata: ${metadataResult.error}`);
      }

      const stakingTokenAddress = formData.selectedToken?.rewardToken;
      if (stakingTokenAddress && contractAddress) {
        setLoaderText("Checking token allowance...");
        await ensureAllowance(stakingTokenAddress, contractAddress, rewardAmount);
      }

      setLoaderText("Creating childpool on blockchain...");
      const { receipt, hash, poolAddress, claimAddress } = await createChildpool(
        contractAddress,
        formData.creatorFee,
        rewardAmount,
        metadataResult.ipfsLink || '',
        formData?.selectedToken?.tokenDecimals || 18 // ✅ pass decimals
      );


      // console.log(poolAddress, "Pool")
      if (receipt && (receipt.status === 'success' || receipt.status === '0x1' || receipt.status === 1)) {
        setTrxHash(hash);

        // ✅ Call API function after success
        await savePoolInfoToAPI(formData, contractAddress, hash, poolAddress, claimAddress);

        handleShow(); // show success modal
      } else {
        handleShow1(); // show failure modal
      }
    } catch (e) {
      console.error("Error creating childpool:", e);
      handleShow1();
    } finally {
      setLoader(false);
      setLoaderText("");
    }
  };

  const savePoolInfoToAPI = async (formData, rootPool, hash, childPool, claimAddress) => {
    try {
      setLoaderText("Saving pool info...");

      const payload = {
        rootPool: rootPool?.toLowerCase(),
        contractAddress: childPool?.toLowerCase(),
        childContractHash: hash?.toLowerCase(),
        tagline: formData.tagline,
        poolDescription: formData.poolDescription,
        creatorFeePercent: formData.creatorFee,
        stakingAmount: Number(formData.stakingAmount),
        apyPercent: formData.apyPercent || 15,
        rootPoolId: formData?.selectedToken?._id,
        claimContract: claimAddress,
        walletAddress: address?.toLowerCase(),
        tokenDecimals: formData?.selectedToken?.tokenDecimals || 18
      };

      const response = await apiRequest({
        url: `${ApiUrl}/pool/child-pool`, // <-- Replace with your actual API endpoint
        method: "POST",
        data: payload,
        auth: true,
      });

      // console.log("✅ Pool info saved successfully:", response);
      setChildPoolId(response?.data?._id);
      return response;
    } catch (error) {
      console.error("❌ Failed to save pool info:", error);
      throw error;
    }
  };


  useEffect(() => {
    if (address) {
      fetchRootTokens();
    }
  }, [address]);

  const filteredTokens = rootTokens?.filter((token) =>
    token.projectName?.toLowerCase().includes(formData.searchTerm?.toLowerCase())
  );

  return (
    <>
      {loader && <Loader loadingText={loaderText} />}
      <section className="childpool">
        {
          theme === 'dark' ? <img src="\assets\bannershade.png" className="bannershade" />
            : <img src='\assets\whiteshade.png' className='bannershade' />
        }
        <div className="custom-container">
          <div className="mainbox">
            <div className="upperhead">
              <h2>Create Child Pool</h2>
              <p>Set terms and launch your pool.</p>
            </div>
            <div className="stepscontent">
              <div className="innerpublicpoll">
                <StepIndicator currentStep={currentStep} />

                {currentStep === 1 && (
                  <BasicInfoStep
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors}
                    filteredTokens={filteredTokens}
                    onNext={() => handleNextStep(2)}
                  />
                )}

                {currentStep === 2 && (
                  <FeesStep
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors}
                    onNext={() => handleNextStep(3)}
                    onBack={handlePreviousStep}
                  />
                )}

                {currentStep === 3 && (
                  <StakeTokensStep
                    formData={formData}
                    setFormData={setFormData}
                    errors={errors}
                    setErrors={setErrors}
                    onNext={() => handleNextStep(4)}
                    onBack={handlePreviousStep}
                    rewardToken={rewardToken}
                  />
                )}

                {currentStep === 4 && (
                  <FinalizeStep
                    formData={formData}
                    gasInfo={gasInfo}
                    isEstimatingGas={isEstimatingGas}
                    isCreatingPool={isCreatingPool}
                    onFinalize={handleStakeAndFinalize}
                    onBack={handlePreviousStep}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuccessModal
        show={show}
        onHide={handleClose}
        formData={formData}
        trxHash={trxHash}
        cropAddress={cropAddress}
        childPoolId={childPoolId}
        onViewPool={() => {
          handleShow1();
          handleClose();
        }}
        rewardToken={rewardToken}
      />

      <FailureModal
        show={show1}
        onHide={handleClose1}
      />
    </>
  );
};

export default Childpool;